<template>
  <div class="el-tabs__inner el-properties-color">
    <el-form
      :model="fieldProperties"
      :rules="rules"
      :label-position="labelPosition"
      ref="fieldProperties"
    >
      <el-row>
        <el-col :span="24">
        <el-form-item label="Show Comments" v-show="activeField.hasOwnProperty('showComments')">
          <el-switch v-model="activeField.showComments">
          </el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="Label Name"v-show="activeField.hasOwnProperty('label')">
            <el-input v-model="activeField.label">{{
                activeField.label
              }}</el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" v-show="activeField.fieldType != 'Name' || activeField.fieldType != 'Address'">
          <el-form-item
            label="Label Width - px"
            v-show="activeField.hasOwnProperty('label')"
          >
            <el-input-number
              v-model="activeField.labelWidth"
              :min="30"
              :max="1000"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item
        label="Height - px"
        v-show="
          activeField.hasOwnProperty('fieldType') &&
          activeField['fieldType'] == 'Carousel'
        "
      >
        <el-input-number
          v-model="activeField.controlHeight"
          controls-position="right"
        ></el-input-number>
      </el-form-item>

      <!-- Show only when 'isPlacehodlerVisible' key exist -->
      <el-form-item
        label="Placeholder"
        v-show="
          activeField.hasOwnProperty('isPlaceholderVisible') &&
          activeField['isPlaceholderVisible'] == true
        "
      >
        <el-row>
          <el-col :span="5">
            <el-switch v-model="activeField.isPlaceholderVisible"></el-switch>
          </el-col>
          <el-col :span="19">
            <el-input
              v-show="activeField.isPlaceholderVisible"
              v-model="activeField.placeholder"
            >
              {{ activeField.placeholder }}
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <el-row>
        <el-col :span="12">
          <el-form-item
            label="Required field?"
            v-show="activeField.hasOwnProperty('isRequired')"
          >
            <el-switch v-model="activeField.isRequired"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="activeField.fieldType != 'Name' || activeField.fieldType != 'Address' ||activeField.fieldType != 'Divider' || activeField.fieldType != 'Heading' || activeField.fieldType != 'Paragraph' || activeField.fieldType != 'ImageUpload'">
          <el-form-item
            label="Layout - Max value is 24"
            v-show="activeField.hasOwnProperty('span')"
          >
            <el-input-number
              v-model="activeField.span"
              :min="1"
              :max="24"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item
        label="Button text"
        v-show="activeField.hasOwnProperty('buttonText')"
      >
        <el-input v-model="activeField.buttonText">
          {{ activeField.buttonText }}
        </el-input>
      </el-form-item>

      <el-form-item
        label="Code view"
        v-show="activeField.hasOwnProperty('fieldText')"
      >
        <el-input v-model="activeField.fieldText" type="textarea" :rows="10">
          {{ activeField.fieldText }}
        </el-input>
      </el-form-item>

      <!-- <el-form-item label="Helpblock" v-show="activeField.hasOwnProperty('isHelpBlockVisible')">
      <el-switch v-model="activeField.isHelpBlockVisible"></el-switch>
      <el-input v-show="activeField.isHelpBlockVisible" v-model="activeField.helpBlockText">
        {{activeField.helpBlockText}}
      </el-input>
    </el-form-item> -->
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="Active Text"
            v-show="activeField.hasOwnProperty('activeText')"
          >
            <el-input v-model="activeField.activeText">{{
              activeField.activeText
            }}</el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Inactive Text"
            v-show="activeField.hasOwnProperty('inActiveText')"
          >
            <el-input v-model="activeField.inActiveText">{{
              activeField.inActiveText
            }}</el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item
        label="uploadURL"
        v-show="activeField.hasOwnProperty('uploadURL')"
      >
        <el-input v-model="activeField.uploadURL">{{
          activeField.uploadURL
        }}</el-input>
      </el-form-item>

      <el-form-item label="Items" v-show="activeField.hasOwnProperty('items')">
        <li
          v-for="(item, index) in activeField.items"
          :key="index"
          class="properties__optionslist"
        >
          <el-row :gutter="5">
            <el-col :span="20">
              <el-input v-model="item.url">{{ item.url }}</el-input>
            </el-col>
            <el-col :span="4">
              <el-button
                @click="deleteOption(activeField.items, index)"
                v-show="activeField.items.length > 1"
              >
                <i class="el-icon-error"></i>
              </el-button>
            </el-col>
          </el-row>
        </li>
        <el-button type="text" @click="addItem(activeField.items)">
          <i class="el-icon-plus"></i>
          Add more
        </el-button>
      </el-form-item>

      <el-form-item
        label="Options"
        v-if="!activeField.isFromUrl && activeField.options"
      >
        <ul class="properties__optionsul">
          <li class="properties__optionslist">
            <el-row :gutter="5" v-if="activeField.fieldType === 'Instruction'">
              <el-col :span="10"> Label </el-col>
              <el-col :span="10"> Instruction </el-col>
              <el-col :span="4"> </el-col>
            </el-row>
            <el-row :gutter="5" v-else>
              <el-col :span="8"> Label </el-col>
              <el-col :span="8"> Value </el-col>
              <el-col :span="4"> Default </el-col>
              <el-col :span="4"> </el-col>
            </el-row>
          </li>
          <li
            v-for="(item, index) in activeField.options"
            :key="index"
            class="properties__optionslist"
          >
            <el-row :gutter="5">
              <el-col :span="activeField.fieldType === 'Instruction' ? 10 : 8">
                <el-input v-model="item.optionLabel">{{
                  item.optionLabel
                }}</el-input>
              </el-col>
              <el-col :span="activeField.fieldType === 'Instruction' ? 10 : 8">
                <!-- <app-input
                    v-if="activeField.fieldType === 'Instruction'"
                    type="text-editor"
                    id="text-editor-id"
                    :label="$t('message_placeholder')"
                    v-model="item.optionValue"
                  /> -->
                <el-input type="textarea" v-model="item.optionValue" v-if="activeField.fieldType === 'Instruction'">{{
                    item.optionValue
                  }}</el-input>
                <el-input v-model="item.optionValue" v-else>{{
                  item.optionValue
                }}</el-input>
              </el-col>
              <el-col :span="4" v-if="activeField.fieldType != 'Instruction'">
                <el-radio v-model="radioDefault" :label="item.optionValue" @change="updateCheckedValue(item)">
                  <!-- {{ item.optionValue }} -->
                </el-radio>
              </el-col>
              <el-col :span="4">
                <el-button
                  @click="deleteOption(activeField.options, index)"
                  v-show="activeField.options.length > 1"
                >
                  <i class="el-icon-error"></i>
                </el-button>
              </el-col>
            </el-row>
          </li>
        </ul>
        <el-button type="text" @click="addOption(activeField.options)">
          <i class="el-icon-plus"></i>
          Add more
        </el-button>
      </el-form-item>
      
      <el-row v-show="activeField.fieldType === 'Divider'">
        <el-col :span="12">
          <el-form-item label="Divider Width" >
            <el-input-number
              :max="100"
              v-model="activeField.maxwidth"
            ></el-input-number>
            <small>Width Between 10% to 100%</small>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Divider Height">
            <el-input-number
              :min="1"
              v-model="activeField.maxheight"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
        
      <el-row v-show="activeField.fieldType === 'Divider'">
        <el-col :span="12">
          <el-form-item label="Divider Color" >
            <el-input
              type="color"
              v-model="activeField.color"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Divider Type">
            <el-select v-model="dividerType" @change="selectDividerType">
              <el-option value="solid">Solid</el-option>
              <el-option value="dashed">Dashed</el-option>
              <el-option value="dotted">Dotted</el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-show="activeField.fieldType === 'Heading'">
        <el-col :span="24">
          <el-form-item label="Heading Text" >
            <el-input
              type="text"
              v-model="activeField.heading"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Subheading Text">
            <el-input
              type="text"
              v-model="activeField.subheading"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-show="activeField.fieldType === 'Heading'">
        <el-col :span="12">
          <el-form-item label="Heading Size">
             <el-input-number
              :min="14"
              v-model="activeField.size"></el-input-number>
              <small>Set text size in digits</small>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Heading Alignment">
            <el-select v-model="headingAlignment" @change="selectHeadingAlignment">
              <el-option value="left">Left</el-option>
              <el-option value="center">Center</el-option>
              <el-option value="right">Right</el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-show="activeField.fieldType === 'Paragraph'">
        <el-col :span="24">
          <el-form-item label="Paragraph Text" >
            <app-input
              type="text-editor"
              v-model="activeField.paragraph"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-show="activeField.fieldType === 'SelectList'">
              <el-col :span="24">
                <el-form-item label="Input Default Value" >
                  <app-input
                    type="text"
                    v-model="activeField.defaultValue"
                  />
                </el-form-item>
              </el-col>
      </el-row>

      <el-row v-show="activeField.fieldType === 'Paragraph'">
        <el-col :span="12">
          <el-form-item label="Text Size">
             <el-input-number
              :min="14"
              v-model="activeField.size"></el-input-number>
              <small>Set text size in digits</small>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Paragraph Alignment">
            <el-select v-model="headingAlignment" @change="selectHeadingAlignment">
              <el-option value="left">Left</el-option>
              <el-option value="center">Center</el-option>
              <el-option value="right">Right</el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-show="activeField.fieldType === 'ImageUpload'">
        <el-col :span="24">
          <el-form-item label="Image Upload" >
            <!-- <app-input
              type="file"
              :label="$t('attachment')"
              v-model="activeField.imagepath"
            /> -->
            <input id="image" class="form-control" @change="previewImage" type="file">
            <button class="btn btn-sm btn-success " @click.prevent="imageUpload">Upload</button>
          </el-form-item>
          <div v-if="previewUrl">
            <img :src="previewUrl" alt="Preview" style="max-width: 100%; height: auto;">
          </div>
        </el-col>
      </el-row>

      <el-row v-show="activeField.fieldType === 'ImageUpload'">
        <el-col :span="24">
          <el-form-item label="Description" >
            <app-input
              type="text-editor"
              v-model="activeField.imagetext"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-show="activeField.fieldType === 'ImageUpload'">
        <el-col :span="24">
          <el-form-item label="Section Height">
             <el-input-number
              :val="150"
              v-model="activeField.size"></el-input-number>
              <small>Section Height</small>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="Image Upload Text Alignment">
            <el-select v-model="headingAlignment" @change="selectHeadingAlignment">
              <el-option value="left">Left</el-option>
              <el-option value="center">Center</el-option>
              <el-option value="right">Right</el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row v-show="activeField.fieldType === 'Name'">
        <el-col :span="24">
          <el-form-item label="First Name" >
            <el-input
              type="text"
              v-model="activeField.firstname"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Last Name">
            <el-input
              type="text"
              v-model="activeField.lastname"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-show="activeField.fieldType === 'Address'">
        <el-col :span="24">
          <el-form-item label="Street Address 1" >
            <el-input
              type="text"
              v-model="activeField.streetAddress1Label"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Street Address 2">
            <el-input
              type="text"
              v-model="activeField.streetAddress2Label"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-show="activeField.fieldType === 'Address'">
        <el-col :span="24">
          <el-form-item label="City" >
            <el-input
              type="text"
              v-model="activeField.cityLabel"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="State / Province">
            <el-input
              type="text"
              v-model="activeField.stateLabel"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-show="activeField.fieldType === 'Address'">
        <el-col :span="24">
          <el-form-item label="Postal / Zip Code" >
            <el-input
              type="text"
              v-model="activeField.postalLabel"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item
        label="Table Columns"
        v-show="activeField.fieldType === 'TableComponent'"
      >
        <ul class="properties__optionsul">
          <li class="properties__optionslist">
            <el-row :gutter="5">
              <el-col :span="7"> Prop </el-col>
              <el-col :span="7"> Label </el-col>
              <el-col :span="7"> Width </el-col>
              <el-col :span="3"> </el-col>
            </el-row>
          </li>
          <li
            v-for="(column, index) in activeField.tableColumns"
            :key="index"
            class="properties__optionslist"
          >
            <el-row :gutter="5">
              <el-col :span="7">
                <el-input v-model="column.prop">{{ column.prop }}</el-input>
              </el-col>
              <el-col :span="7">
                <el-input v-model="column.label">{{ column.label }}</el-input>
              </el-col>
              <el-col :span="7">
                <el-input @change="columnWidth" v-model="column.width">{{
                  column.width
                }}</el-input>
              </el-col>
              <el-col :span="3">
                <el-button
                  @click="
                    deleteColumn(activeField.tableColumns, index, column.prop)
                  "
                  v-show="activeField.tableColumns.length > 1"
                >
                  <i class="el-icon-error"></i>
                </el-button>
              </el-col>
            </el-row>
          </li>
        </ul>
        <el-button type="text" @click="addColumn(activeField.tableColumns)">
          <i class="el-icon-plus"></i>
          Add more
        </el-button>
      </el-form-item>

      <el-form-item
        label="Html Content"
        v-show="activeField.hasOwnProperty('htmlContent')"
      >
        <el-input
          :rows="10"
          type="textarea"
          v-model="activeField.htmlContent"
          >{{ activeField.htmlContent }}</el-input
        >
      </el-form-item>

      <el-button
        v-show="activeField.hasOwnProperty('advancedOptions')"
        @click="advancedPropsVisible = true"
        style="width: 100%"
        type="success"
      >
        Advanced Options
      </el-button>
      <el-dialog
        :close-on-click-modal="false"
        title="Advanced Options"
        :visible.sync="advancedPropsVisible"
      >
        <el-form ref="OptionsForm" :rules="dialogRules">
          <rating-advanced-props
            v-if="activeField.fieldType === 'Rating'"
          ></rating-advanced-props>
          <text-input-advanced-props
            v-if="activeField.fieldType === 'TextInput'"
          ></text-input-advanced-props>
          <email-advanced-props
            v-if="activeField.fieldType === 'Email'"
          ></email-advanced-props>
          <phone-advanced-props
            v-if="activeField.fieldType === 'Phone'"
          ></phone-advanced-props>
          <html-advanced-props
            v-if="activeField.fieldType === 'HtmlComponent'"
          ></html-advanced-props>
          <number-input-advanced-props
            v-if="activeField.fieldType === 'NumberInput'"
          ></number-input-advanced-props>
          <select-list-advanced-props
            v-if="activeField.fieldType === 'SelectList'"
          ></select-list-advanced-props>
          <instruction-advanced-props
            v-if="activeField.fieldType === 'Instruction'"
          ></instruction-advanced-props>
          <divider-advanced-props
            v-if="activeField.fieldType === 'Divider'"
          ></divider-advanced-props>
          <options-advanced-props
            v-if="
              activeField.fieldType === 'RadioButton' ||
              activeField.fieldType === 'Checkbox'
            "
          ></options-advanced-props>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmForm">Confirm</el-button>
        </div>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import RatingAdvancedProps from "./RatingAdvancedProps";
import TextInputAdvancedProps from "./TextInputAdvancedProps.vue";
import EmailAdvancedProps from "./EmailAdvancedProps.vue";
import PhoneAdvancedProps from "./PhoneAdvancedProps.vue";
import HtmlAdvancedProps from "./HtmlAdvancedProps.vue";
import NumberInputAdvancedProps from "./NumberInputAdvancedProps.vue";
import OptionsAdvancedProps from "./OptionsAdvancedProps.vue";
import SelectListAdvancedProps from "./SelectListAdvancedProps.vue";
import InstructionAdvancedProps from "./InstructionAdvancedProps.vue";

import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import AppLibrary from "../../../../../Helpers/AppLibrary";

import {axiosPost} from "@/app/Helpers/AxiosHelper";
import {FORM_BUILDER_IMAGE_UPLOAD} from "@/app/Config/ApiUrl";

export default {
  extends: AppLibrary,
  mixins: [FormMixin],
  name: "Properties",
  components: {
    RatingAdvancedProps,
    TextInputAdvancedProps,
    EmailAdvancedProps,
    PhoneAdvancedProps,
    HtmlAdvancedProps,
    NumberInputAdvancedProps,
    OptionsAdvancedProps,
    SelectListAdvancedProps,
    InstructionAdvancedProps,
  },
  // store: ["activeField"], // Get the form data from Home
  data() {
    return {
      radioDefault: '',
      selectedImage: null,
      previewUrl: null,
      dividerType: '',
      headingAlignment: '',
      labelPosition: "top",
      fieldProperties: {},
      rules: {},
      advancedPropsVisible: false,
      dialogRules: {
        dataUrl: [
          { required: true, message: "Please input url", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    activeField() {
      return this.$store.state.formBuilder.activeField;
    }
  },
  mounted() {
    
    
    //   "activeField.hasOwnProperty('span') ->",
    //   this.activeField.hasOwnProperty("span")
    // );
  },
  methods: {
    selectDividerType() {
      this.activeField.dividerType = this.dividerType;
    },
    selectHeadingAlignment() {
      this.activeField.alignment = this.headingAlignment;
    },
    deleteOption(option, index) {
      this.$delete(option, index);
    },
    addOption(option) {
      let count = option.length + 1;
      option.push({
        optionLabel: "Option Label " + count,
        optionValue: "Option " + count,
      });
    },
    addItem(item) {
      item.push({
        url: "",
      });
    },
    deleteColumn(column, index, prop) {
      this.$delete(column, index);
      this.activeField.tableDatas.forEach(function (ele) {
        delete ele[prop];
      });
    },
    addColumn(tableColumns) {
      tableColumns.push({
        prop: "",
        label: "",
        width: 180,
      });
    },
    columnWidth(value) {
      if (value && isNaN(value)) {
        this.$message.error("Column width should be a number!");
      }
    },
    confirmForm() {
      this.$refs["OptionsForm"].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          
          return false;
        }
      });
      this.$toastr.s('Advanced Properties Set Successfully');
      this.advancedPropsVisible = false;
    },
    previewImage(event) {
      const file = event.target.files[0];
      if (file) {
        // Check if the selected file is an image
        if (!/\.(jpg|jpeg|png|gif)$/i.test(file.name)) {
          alert('Please select a valid image file (JPEG, JPG, PNG, GIF).');
          return;
        }
        this.selectedImage = file;
        this.previewUrl = URL.createObjectURL(file);
      }
    },
    imageUpload(e) {
      const file = this.selectedImage;
      if (file) {
        const formData = new FormData();
        formData.append('image', file);

        // Make a POST request to your Laravel backend to handle the file upload
        axiosPost(FORM_BUILDER_IMAGE_UPLOAD, formData)
        .then((res) => {
            this.$toastr.s("Image upload completed!");
            this.activeField.imagepath = res.data;
          })
          .catch(error => {
            this.$toastr.e("Error uploading image. Please try again.");
          });
      } else {
        alert('No image selected to upload.');
      }
    },
    updateCheckedValue(item) {
      this.activeField.componentValue =  item.optionValue;
    }
  },
};
</script>

<style lang="scss" scoped>
.properties__optionslist {
  margin-bottom: 5px;
  list-style: none;
  list-style-type: none;
}
.properties__optionsul {
  padding: 0;
}
</style>
